<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <div class="sk__item" v-for="idx in 2" :key="idx">
        <div class="sk__left">
          <el-skeleton-item variant="image" class="sk__image" />
          <div class="sk__left-inner">
            <el-skeleton-item variant="p" class="sk__name" />
            <el-skeleton-item variant="p" class="sk__name" />
          </div>
        </div>
        <el-skeleton-item variant="p" class="sk__text" />
        <el-skeleton-item variant="p" class="sk__text" />
        <el-skeleton-item variant="p" class="sk__text" />
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  width: 100%;
  border: 1px solid #000000;
  border-radius: 15px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  padding: 14px 19px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 15px;

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__left {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
  }

  &__image {
    width: 140px;
    height: 175px;
    border-radius: 15px;
    flex-shrink: 0;
  }

  &__name {
    width: 175px;
    height: 39px;
  }

  &__text {
    width: 50px;
    height: 30px;

    &:last-child {
      width: 20%;
    }
  }
}

@media (max-width: 900px) {
  .sk {
    &__image {
      width: 120px;
    }

    &__name {
      width: 150px;
    }
  }
}

@media (max-width: 700px) {
  .sk {
    &__item {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }
}

@media (max-width: 500px) {
  .sk {
    &__item {
      align-items: center;
    }

    &__left {
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>